import { useMemo } from 'react';
import { ProfileSection, ProfileSections } from '../../components/ProfileSection';

interface Props {
    data: any[] | undefined;
};

export default function Expertise({ data }: Props) {
    const expertises = useMemo(() => Array.isArray(data)
        ? [...data].sort((a, b) => a.expert.orderId - b.expert.orderId)
        : null, [data]);

    return (
        <ProfileSections gap='md'>
            {expertises?.map((item, index) => <ProfileSection
                key={index}
                layout='inline'
                title={item.expert.title}
            >
                {item.skills.map((skill: any, skillIndex: number) => <span key={skillIndex}>
                    {skill.title}
                </span>)}
            </ProfileSection>)}
        </ProfileSections>
    );
};
